import { Component, OnInit, Renderer, ViewChild, ElementRef, Directive, Type, OnDestroy } from '@angular/core';
import { ROUTES } from '../.././sidebar/sidebar.component';
import { Router, ActivatedRoute, NavigationEnd, NavigationStart } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { ApiService } from 'src/app/Services/api.service';
import { SidebarComponent } from 'src/app/sidebar/sidebar.component'
import { UsersAuthService } from 'src/app/users-auth.service';
import { HttpClient } from '@angular/common/http';
import { DataService } from 'src/app/data.service';

const misc: any = {
    navbar_menu_visible: 0,
    active_collapse: true,
    disabled_collapse_init: 0,
};

declare var $: any;
@Component({
    selector: 'app-navbar-cmp',
    templateUrl: 'navbar.component.html',
    styleUrls: ["./navbar.component.scss"],
})

export class NavbarComponent implements OnInit  {
    private listTitles: any[];
    location: Location;
    mobile_menu_visible: any = 0;
    private nativeElement: Node;
    private toggleButton: any;
    private sidebarVisible: boolean;
    TitleGeneral: string;
    private _router: Subscription;
    AdFeedList: any;
    RoleID: any;
    myItemSession: any;
    VerticalList: any;

    MenuJLF: any[];
    MenuList: any[];
    
    @ViewChild('app-navbar-cmp', { static: false }) button: any;

    //constructor(private apiService: ApiService, private http: HttpClient, private _router: Router, private userAuth: UsersAuthService) { }
    constructor(location: Location, private renderer: Renderer, private element: ElementRef, private data: DataService,
        private route: ActivatedRoute, private router: Router, private apiService: ApiService, private http: HttpClient, private userAuth: UsersAuthService) {
        this.location = location;
        this.nativeElement = element.nativeElement;
        this.sidebarVisible = false;
        this.getListMenu();
        var side: SidebarComponent;
        this.myItemSession = localStorage.getItem("SessionMAO");
        this.myItemSession = JSON.parse(this.myItemSession);
        this.RoleID = this.myItemSession.RoleID;
        //var jlf = side.getListMenu();
    }

    getListMenu(): any {
        //let userStr = sessionStorage.getItem("SessionMAO"); //20200422
        let userStr = localStorage.getItem("SessionMAO");
        let UserObj = $.parseJSON(userStr);
        var apiServicex: ApiService;
        this.apiService.getMenuByUser(UserObj.UserID)
            .then((results: any) => {
                this.MenuList = [];
                this.MenuList = results.Value;
                //if (this.MenuList.length > 0)
                this.CreateRouteInfox(this.MenuList);
            })
            .catch(err =>
                console.log('Error getListMenu', err));
    }

    SetVerticalWithAdFeed() {
        var Menus = []

        if (this.VerticalList.length > 0) {
            if (this.AdFeedList != null) {
                if (this.AdFeedList.length > 0) {
                    this.VerticalList.forEach(vertical => {
                        var item = {
                            "MenuID": vertical.VerticalID + 50,
                            "path": "/admin",
                            "title": vertical.VerticalName,
                            "type": "sub",
                            "icontype": "store",
                            "ab": "R",
                            "collapse": vertical.VerticalName,
                            "CssClass": "store",
                            "Active": true,
                            "children": []
                        };
                        this.AdFeedList.forEach(adFeed => {

                            if (adFeed.VerticalID == vertical.VerticalID) {
                                var elementY = adFeed.ExchangeName;
                                var idxline1 = elementY.indexOf("<br/>", 0);
                                // var line1 = elementY.substring(0, idxline1);
                                // var line2 = elementY.substring(idxline1, elementY.length).replace("<br/>", "");
                                var line1 = elementY;
                                var vChildMenuTest = {
                                    "MenuID": Math.floor(Math.random() * (2000 - 1000 + 1) + 1000),
                                    "path": "advertisercampaign",
                                    "id": adFeed.AdFeedID,
                                    "title": line1,
                                    //"title2": line2,
                                    "ab": "R",
                                    "CssClass": 'fa fa-cubes',
                                    "Active": true
                                    //"pathMatch": 'full'
                                };
                                item.children.push(vChildMenuTest);
                            }
                        }); //End AdFeeLIst forEach
                        if (item.children.length > 0)
                            this.listTitles.push(item);
                    });
                }
            }
        }


        //this.menuItems = this.ROUTE2;
        //this.copyMessage(JSON.stringify(this.menuItems));

    }

    getListVertical(): void {
        //this.apiService.getVerticalList()
        this.apiService.getVerticalList()
            .then((results: any) => {
                this.VerticalList = [];
                this.VerticalList = results.Value;
                this.VerticalList = this.VerticalList.filter(v => v.Active == true);
                //var NewVerticals = [];
                if (this.VerticalList.length > 0) {
                    this.VerticalList.sort((a, b) => (a.VerticalName > b.VerticalName) ? 1 : -1)
                }
                if (this.RoleID == 1) {
                    this.apiService.getAdFeedList()
                        .then((results: any) => {
                            var feedList = [];
                            feedList = results.Value;
                            this.AdFeedList = [];
                            this.AdFeedList = feedList;
                            if (this.AdFeedList.length > 0) {
                                this.AdFeedList.sort((a, b) => (a.AdFeedName.toUpperCase() > b.AdFeedName.toUpperCase()) ? 1 : -1)
                            }
                            this.SetVerticalWithAdFeed();
                        })
                        .catch(err => {
                            console.log('Error', err);

                        });


                }
                if (this.RoleID == 3) {

                    //this.apiService.getAdFeedListByPublisher(this.myItemSession.PublisherID)
                    this.apiService.GetAdFeedOfMenuByPublisher(this.myItemSession.PublisherID)
                        .then((results: any) => {
                            var feedList = [];
                            feedList = results.Value;
                            this.AdFeedList = [];
                            this.AdFeedList = feedList;
                            if (this.AdFeedList.length > 0)
                                this.AdFeedList.sort((a, b) => (a.AdFeedName.toUpperCase() > b.AdFeedName.toUpperCase()) ? 1 : -1)
                            this.SetVerticalWithAdFeed();
                        })
                        .catch(err => {
                            console.log('Error', err);

                        });
                }
                if (this.RoleID == 2 || this.RoleID == 5) {
                    this.apiService.getAdFeedListByUser(this.myItemSession.UserID)
                        .then((results: any) => {
                            var feedList = [];
                            feedList = results.Value;
                            this.AdFeedList = [];
                            this.AdFeedList = feedList;
                            if (this.AdFeedList.length > 0)
                                this.AdFeedList.sort((a, b) => (a.AdFeedName.toUpperCase() > b.AdFeedName.toUpperCase()) ? 1 : -1)
                            this.SetVerticalWithAdFeed();
                        })
                        .catch(err => {
                            console.log('Error', err);

                        });



                    this.SetVerticalWithAdFeed();
                }

            })
            .catch(err => {

                console.log('Error', err)
            });
    }

    CreateRouteInfox(menus) {
        let myItemSession = localStorage.getItem("SessionMAO");
        let GeneralMenusX = [] = Object.values(menus)
        let MainMenus = [] = menus;
        var GenerateMenu = [];
        let valoresy = [];
        var ParentMenu2 = menus.filter(x => x.FatherID == null);
        var GeneralMenu2 = [];
        setTimeout(() => {
            ParentMenu2.forEach(element => {
                var childTemporal = {
                    "MenuID": element.MenuID,
                    //"CompanyID": childs[idx].ComapnyID,
                    "path": element.ComponentName,
                    "title": element.Menu,
                    "type": "",
                    "icontype": element.CssClass,
                    "ab": "R",
                    "collapse": element.Menu.toLowerCase(),
                    "CssClass": element.CssClass,
                    "Active": element.Active,
                    "children": []
                    //"active":false,
                }
                var hijos = menus.filter(y => y.FatherID == element.MenuID);
                if (hijos.length > 0) {
                    childTemporal.type = "sub";
                    hijos.forEach(MenuHijo => {
                        var ChildHijo = {
                            "MenuID": MenuHijo.MenuID,
                            "path": MenuHijo.ComponentName,
                            "title": MenuHijo.Menu,
                            "ab": "R",
                            "CssClass": MenuHijo.CssClass,
                            "Active": MenuHijo.Active,
                            "pathMatch": 'full'
                        }
                        childTemporal.children.push(ChildHijo);
                    });
                    //element.children = hijos;
                }
                else
                    childTemporal.type = "link";
                if (childTemporal.MenuID == 9) {
                    childTemporal.type = "sub";
                }
                GeneralMenu2.push(childTemporal);
            });


            var idx = GeneralMenu2.findIndex(function (element) {
                return element.MenuID == 9
            })
            if (idx != -1) {
                //get AdFeedList for Menu
                if (this.RoleID == 2 || this.RoleID == 5) {
                    this.apiService.getAdFeedListByUser(this.myItemSession.UserID)
                        .then((results: any) => {
                            this.AdFeedList = [];
                            this.AdFeedList = results.Value;
                            if (this.AdFeedList.length > 0) {
                                this.AdFeedList.forEach(element => {
                                    var vChildMenuTest = {
                                        "MenuID": Math.floor(Math.random() * (2000 - 1000 + 1) + 1000),
                                        "path": "advertisercampaign",
                                        "id": element.AdFeedID,
                                        "title": element.ExchangeName.replace("<br/>", " "),
                                        "ab": "R",
                                        "CssClass": 'fa fa-cubes',
                                        "Active": true
                                        //"pathMatch": 'full'
                                    };
                                    GeneralMenu2[idx].children.push(vChildMenuTest);
                                });
                            }
                        })
                        .catch(err =>
                            console.log('Error getListMenu', err));
                }
                else if (this.RoleID == 3) {

                    //this.apiService.getAdFeedListByPublisher(this.myItemSession.PublisherID)
                    this.apiService.GetAdFeedOfMenuByPublisher(this.myItemSession.PublisherID)
                        .then((results: any) => {
                            this.AdFeedList = [];
                            this.AdFeedList = results.Value;
                            if (this.AdFeedList.length > 0) {
                                this.AdFeedList.forEach(element => {
                                    var vChildMenuTest = {
                                        "MenuID": Math.floor(Math.random() * (2000 - 1000 + 1) + 1000),
                                        "path": "advertisercampaign",
                                        "id": element.AdFeedID,
                                        "title": element.ExchangeName.replace("<br/>", " "),
                                        "ab": "R",
                                        "CssClass": 'fa fa-cubes',
                                        "Active": true
                                        //"pathMatch": 'full'
                                    };
                                    GeneralMenu2[idx].children.push(vChildMenuTest);
                                });
                            }
                        })
                        .catch(err => {
                            console.log('Error getListMenu', err);
                        });
                }
                else {
                    this.apiService.getAdFeedList()
                        .then((results: any) => {
                            this.AdFeedList = [];
                            this.AdFeedList = results.Value;
                            if (this.AdFeedList.length > 0) {
                                this.AdFeedList.forEach(element => {
                                    var elementY = element.ExchangeName.replace(new RegExp('\n', 'g'), "<br />");
                                    var vChildMenuTest = {
                                        "MenuID": Math.floor(Math.random() * (2000 - 1000 + 1) + 1000),
                                        "path": "advertisercampaign",
                                        "id": element.AdFeedID,
                                        "title": elementY.replace("<br/>", " "),
                                        "ab": "R",
                                        "CssClass": 'fa fa-cubes',
                                        "Active": true
                                        //"pathMatch": 'full'
                                    };
                                    GeneralMenu2[idx].children.push(vChildMenuTest);
                                });
                            }
                        })
                        .catch(err => {
                            console.log('Error getListMenu', err);
                        });
                }

            }
            //this.listTitles = GeneralMenu2;

            this.listTitles = GeneralMenu2;
            this.getListVertical();
            //console.log("ListTitles: " + JSON.stringify( this.listTitles));

        }, 300);
    }

    minimizeSidebar() {
        const body = document.getElementsByTagName('body')[0];

        if (misc.sidebar_mini_active === true) {
            body.classList.remove('sidebar-mini');
            misc.sidebar_mini_active = false;

        } else {
            setTimeout(function () {
                body.classList.add('sidebar-mini');

                misc.sidebar_mini_active = true;
            }, 300);
        }

        // we simulate the window Resize so the charts will get updated in realtime.
        const simulateWindowResize = setInterval(function () {
            window.dispatchEvent(new Event('resize'));
        }, 180);

        // we stop the simulation of Window Resize after the animations are completed
        setTimeout(function () {
            clearInterval(simulateWindowResize);
        }, 1000);
    }

    hideSidebar() {
        const body = document.getElementsByTagName('body')[0];
        const sidebar = document.getElementsByClassName('sidebar')[0];

        if (misc.hide_sidebar_active === true) {
            setTimeout(function () {
                body.classList.remove('hide-sidebar');
                misc.hide_sidebar_active = false;
            }, 300);
            setTimeout(function () {
                sidebar.classList.remove('animation');
            }, 600);
            sidebar.classList.add('animation');

        } else {
            setTimeout(function () {
                body.classList.add('hide-sidebar');
                // $('.sidebar').addClass('animation');
                misc.hide_sidebar_active = true;
            }, 300);
        }

        // we simulate the window Resize so the charts will get updated in realtime.
        const simulateWindowResize = setInterval(function () {
            window.dispatchEvent(new Event('resize'));
        }, 180);

        // we stop the simulation of Window Resize after the animations are completed
        setTimeout(function () {
            clearInterval(simulateWindowResize);
        }, 1000);
    }
   

    ngOnInit() {

        //this.listTitles = ROUTES.filter(listTitle => listTitle);
        const navbar: HTMLElement = this.element.nativeElement;
        const body = document.getElementsByTagName('body')[0];
        this.toggleButton = navbar.getElementsByClassName('navbar-toggler')[0];
        if (body.classList.contains('sidebar-mini')) {
            misc.sidebar_mini_active = true;
        }
        if (body.classList.contains('hide-sidebar')) {
            misc.hide_sidebar_active = true;
        }
        this._router = this.router.events.filter(event => event instanceof NavigationEnd).subscribe((event: NavigationEnd) => {
            this.sidebarClose();

            const $layer = document.getElementsByClassName('close-layer')[0];
            if ($layer) {
                $layer.remove();
            }
        });


    }

    onResize(event) {
        if ($(window).width() > 991) {
            return false;
        }
        return true;
    }
    
    sidebarOpen() {
        var $toggle = document.getElementsByClassName('navbar-toggler')[0];
        const toggleButton = this.toggleButton;
        const body = document.getElementsByTagName('body')[0];
        setTimeout(function () {
            toggleButton.classList.add('toggled');
        }, 500);
        body.classList.add('nav-open');
        setTimeout(function () {
            $toggle.classList.add('toggled');
        }, 430);

        var $layer = document.createElement('div');
        $layer.setAttribute('class', 'close-layer');


        if (body.querySelectorAll('.main-panel')) {
            document.getElementsByClassName('main-panel')[0].appendChild($layer);
        } else if (body.classList.contains('off-canvas-sidebar')) {
            document.getElementsByClassName('wrapper-full-page')[0].appendChild($layer);
        }

        setTimeout(function () {
            $layer.classList.add('visible');
        }, 100);

        $layer.onclick = function () { //asign a function
            body.classList.remove('nav-open');
            this.mobile_menu_visible = 0;
            this.sidebarVisible = false;

            $layer.classList.remove('visible');
            setTimeout(function () {
                $layer.remove();
                $toggle.classList.remove('toggled');
            }, 400);
        }.bind(this);

        body.classList.add('nav-open');
        this.mobile_menu_visible = 1;
        this.sidebarVisible = true;
    };

    sidebarClose() {
        var $toggle = document.getElementsByClassName('navbar-toggler')[0];
        const body = document.getElementsByTagName('body')[0];
        this.toggleButton.classList.remove('toggled');
        var $layer = document.createElement('div');
        $layer.setAttribute('class', 'close-layer');

        this.sidebarVisible = false;
        body.classList.remove('nav-open');
        // $('html').removeClass('nav-open');
        body.classList.remove('nav-open');
        if ($layer) {
            $layer.remove();
        }

        setTimeout(function () {
            $toggle.classList.remove('toggled');
        }, 400);

        this.mobile_menu_visible = 0;
    };

    sidebarToggle() {
        if (this.sidebarVisible === false) {
            this.sidebarOpen();
        } else {
            this.sidebarClose();
        }
    }

    getTitle() {

        let titlee: any = this.location.prepareExternalUrl(this.location.path());
        if (this.listTitles != undefined)
            if (this.listTitles.length > 0)
                for (let i = 0; i < this.listTitles.length; i++) {
                    if (this.listTitles[i].type === "link" && this.listTitles[i].path === titlee) {
                        return this.listTitles[i].title;
                    } else if (this.listTitles[i].type === "sub") {

                        for (let j = 0; j < this.listTitles[i].children.length; j++) {
                            if (this.listTitles[i].children[j].MenuID < 1000) {
                                let subtitle = this.listTitles[i].path + '/' + this.listTitles[i].children[j].path;
                                if (subtitle === titlee) {
                                    this.TitleGeneral = this.listTitles[i].children[j].title;
                                    return this.TitleGeneral;
                                }
                            }
                            else {
                                let subtitle = this.listTitles[i].path + '/' + this.listTitles[i].children[j].path + "/" + this.listTitles[i].children[j].id + '/pe';
                                if (subtitle === titlee) {
                                    //if (titlee.includes(subtitle)) {
                                    this.TitleGeneral = this.listTitles[i].children[j].title;
                                    return this.TitleGeneral;
                                }
                            }
                        }
                    }
                }

        return this.TitleGeneral;
        //return 'Dashboard';    
    }
    getPath() {
        return this.location.prepareExternalUrl(this.location.path());
    }
}
